var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 40.5C10.9 40.5 9.95833 40.1083 9.175 39.325C8.39167 38.5417 8 37.6 8 36.5V32.5C8 31.9333 8.19167 31.4583 8.575 31.075C8.95833 30.6917 9.43333 30.5 10 30.5C10.5667 30.5 11.0417 30.6917 11.425 31.075C11.8083 31.4583 12 31.9333 12 32.5V36.5H36V32.5C36 31.9333 36.1917 31.4583 36.575 31.075C36.9583 30.6917 37.4333 30.5 38 30.5C38.5667 30.5 39.0417 30.6917 39.425 31.075C39.8083 31.4583 40 31.9333 40 32.5V36.5C40 37.6 39.6083 38.5417 38.825 39.325C38.0417 40.1083 37.1 40.5 36 40.5H12ZM22 16.2L18.25 19.95C17.85 20.35 17.375 20.5417 16.825 20.525C16.275 20.5083 15.8 20.3 15.4 19.9C15.0333 19.5 14.8417 19.0333 14.825 18.5C14.8083 17.9667 15 17.5 15.4 17.1L22.6 9.90001C22.8 9.70001 23.0167 9.55834 23.25 9.47501C23.4833 9.39167 23.7333 9.35001 24 9.35001C24.2667 9.35001 24.5167 9.39167 24.75 9.47501C24.9833 9.55834 25.2 9.70001 25.4 9.90001L32.6 17.1C33 17.5 33.1917 17.9667 33.175 18.5C33.1583 19.0333 32.9667 19.5 32.6 19.9C32.2 20.3 31.725 20.5083 31.175 20.525C30.625 20.5417 30.15 20.35 29.75 19.95L26 16.2V30.5C26 31.0667 25.8083 31.5417 25.425 31.925C25.0417 32.3083 24.5667 32.5 24 32.5C23.4333 32.5 22.9583 32.3083 22.575 31.925C22.1917 31.5417 22 31.0667 22 30.5V16.2Z",
    fill: "#4068BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6130e07d113ed997b47f94fc7ceeac00.svg";
export { ForwardRef as ReactComponent };